
import { ResumeContact } from '@/models/Resume'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: "contact",
    props: {
        contact: {
            type: Object as PropType<ResumeContact>,
            required: true
        } 
    },
    computed: {
        tel(): string {
            return `tel:${this.contact.phone.split(" ").join("") }`
        },
        mailto(): string {
            return `mailto:${this.contact.email}`
        }
    }
})
